import Util from "@/Master/Util";

import { sendGTMEvent } from '@next/third-parties/google'

/**
 * GoogleTrack.ts
 *
 * 一个用于初始化和管理 Google Analytics 和 Google Tag Manager 的跟踪工具类。
 */
export default class GoogleTrack {
    private static readonly tag: string = `[GoogleGTM]`;

    /**
     * 向 Google Tag Manager 推送自定义事件。
     * @param eventName - 事件名称
     * @param eventData - 事件自定义参数
     */
    static pushGTMEvent(eventName: string, eventData: Record<string, any>): void {
        try {
            const tagManagerArgs = {
                dataLayer: {
                    ...eventData
                },
                dataLayerName: `gtm_${eventName}`//增加gtm标记
            }
            const dataLayer = {
                ...eventData
            };
            const dataLayerName = `gtm_${eventName}`//增加gtm标记
            sendGTMEvent(dataLayer,dataLayerName)
            if (Util.isLog) {
                console.log(`${this.tag} 推送 GTM 事件:`, tagManagerArgs);
            }
        } catch (error) {
            if (Util.isLog) {
                console.error(`${this.tag} 推送 GTM 事件失败:`, error);
            }
        }
    }
}
